(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("examDetails", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/account/exam/examDetailsView.html",
            controller: ["examDetailsResource", "messageService", "$uibModal", "$scope", "$rootScope", "$state", "$sessionStorage", "$window", "EXAMDETAIL_STATUS", ExamDetailsCtrl],
            controllerAs: "vm"
        };
        function ExamDetailsCtrl(examDetailsResource, messageService, $uibModal, $scope, $rootScope, $state, $sessionStorage, $window, EXAMDETAIL_STATUS) {
            /* When this component is opened:
                1. Exam attempts results AJS (admin)
                2. Exam attempts results A2  (admin)
                3. When a user finishes the exam
                4. User looks in a learning plan
            */
            var vm = this;
            vm.loading = true;
            vm.fromState = $rootScope.fromState.name;
            //This is a hidden parameter set when an admin navigates from Exam-Attempts-Result in AJS
            if ($state.params.person)
                sessionStorage.setItem('examDetailsPerson', $state.params.person);
            if (sessionStorage.getItem('examDetailsPerson'))
                vm.person = sessionStorage.getItem('examDetailsPerson');
            /*Sometimes this is a hidden param and other times it is in the URL
                Hidden --> two non-admin pages
                Showing --> two admin pages*/
            if ($state.params.examAttemptId)
                $sessionStorage.examDetailsExamAttemptId = $state.params.examAttemptId;
            if ($sessionStorage.examDetailsExamAttemptId)
                vm.examAttemptId = $sessionStorage.examDetailsExamAttemptId;
            if (!vm.examAttemptId) {
                $state.go("main.learningPlan");
                return;
            }
            vm.state = "learner";
            if ($state.$current.name === "main.evaluations.examAttemptsDetails")
                vm.state = "admin";
            var promise;
            if (vm.state === "learner") {
                promise = examDetailsResource.getExamDetailViewModelLearnerAccess({ examAttemptId: vm.examAttemptId }).$promise;
            }
            else if (vm.state === "admin") {
                promise = examDetailsResource.getExamDetailViewModelAdminAccess({ person: vm.person, examAttemptId: vm.examAttemptId }).$promise;
            }
            else
                return;
            promise.then(function (data) {
                if (data.showExamDetailId === 0) {
                    //Exam Details is not enabled redirect to learning item modal
                    $state.go("main.learningPlan");
                    return;
                }
                else {
                    vm.examInformation = data;
                    vm.examInformation.startDate = moment.utc(data.startDate).local().format("LLL");
                    vm.examInformation.endDate = moment.utc(data.endDate).local().format("LLL");
                    vm.showCorrect = vm.examInformation.showExamDetailCorrectAnswer;
                    vm.examStatus = vm.examInformation.examStatus === 4 ? "Failed" : "Passed";
                    vm.examCategories = data.examCategories;
                    vm.number = data.pathNumber;
                    vm.version = data.pathVersion;
                    vm.loading = false;
                }
            }, function (error) {
                messageService.error(error);
            });
            vm.headerTextPreview = function (headerText) {
                $uibModal.open({
                    templateUrl: "headerTextPreview.html",
                    controller: ["$scope", "headerText", function ($scope, headerText) {
                            var vm = this;
                            vm.headerText = headerText;
                        }],
                    controllerAs: "vm",
                    size: "lg",
                    scope: $scope,
                    animation: false,
                    resolve: {
                        headerText: function () {
                            return headerText;
                        }
                    }
                }).result.catch(angular.noop);
            };
            vm.headerImagePreview = function (headerImage) {
                $uibModal.open({
                    templateUrl: "headerImagePreview.html",
                    controller: ["$scope", "headerImage", function ($scope, headerImage) {
                            var vm = this;
                            vm.headerImage = headerImage;
                        }],
                    controllerAs: "vm",
                    scope: $scope,
                    animation: false,
                    resolve: {
                        headerImage: function () {
                            return headerImage;
                        }
                    }
                }).result.catch(angular.noop);
            };
            vm.resourceDocumentsPreview = function (questionHeaderFiles) {
                $uibModal.open({
                    templateUrl: "resourceDocumentsPreview.html",
                    controller: ["$scope", "questionHeaderFiles", function ($scope, questionHeaderFiles) {
                            var vm = this;
                            vm.questionHeaderFiles = questionHeaderFiles;
                        }],
                    controllerAs: "vm",
                    scope: $scope,
                    animation: false,
                    resolve: {
                        questionHeaderFiles: function () {
                            return questionHeaderFiles;
                        }
                    }
                }).result.catch(angular.noop);
            };
            vm.print = function () {
                window.print();
            };
            vm.back = function () {
                $window.history.back();
            };
            vm.getAnswerFeedback = function (question) {
                var answerFeedback = "";
                angular.forEach(question.answers, function (answer) {
                    if (answer.selected && answer.answerFeedback) {
                        answerFeedback += answer.answerFeedback;
                    }
                });
                return answerFeedback;
            };
        }
    });
}());
